import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=05a74d26"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=05a74d26&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a74d26')) {
      api.createRecord('05a74d26', component.options)
    } else {
      api.reload('05a74d26', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=05a74d26", function () {
      api.rerender('05a74d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/Base.vue"
export default component.exports